import React, { useState } from "react";
import { branchRepo } from "../../services";
import { useApp } from "../../context/AppContext";
import { useI18n } from "../../i18n";
import { Badge, Button, Card, Input, Modal, PageHead, useAsync } from "../../components/ui";

const EMPTY = { name: "", phone: "", address: "", openTime: "09:00", closeTime: "19:00" };

export default function Branches() {
  const { orgId, toast, checkQuota } = useApp();
  const { tx } = useI18n();
  const { data: branches, reload } = useAsync(() => branchRepo.all(orgId), [orgId], []);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);

  const save = async () => {
    if (!form.name) return toast(tx("กรอกชื่อสาขา", "Branch name required"), "error");

    // โควตาสาขาตามแพ็กเกจ
    const quota = checkQuota("branches", branches?.length || 0);
    if (!quota.ok) {
      return toast(
        tx(`แพ็กเกจนี้เปิดได้ ${quota.limit} สาขา อัปเกรดแพ็กเกจหรือซื้อสาขาเพิ่มที่หน้าฟีเจอร์เสริม`, `Your plan allows ${quota.limit} branches — upgrade or buy extra quota under Add-ons`),
        "error"
      );
    }

    await branchRepo.create(orgId, { ...form, isMain: !branches?.length });
    setOpen(false);
    setForm(EMPTY);
    reload();
    toast(tx("เพิ่มสาขาเรียบร้อย", "Branch created"), "success");
  };

  return (
    <>
      <PageHead title={tx("จัดการสาขา", "Branch management")} actions={<Button variant="primary" onClick={() => setOpen(true)}>+ {tx("เพิ่มสาขา", "Add branch")}</Button>} />

      <div className="grid-3">
        {(branches || []).map((branch) => (
          <Card key={branch.id} title={branch.name} subtitle={branch.address} actions={branch.isMain ? <Badge tone="indigo">{tx("สำนักงานใหญ่", "HQ")}</Badge> : null}>
            <div className="u-fs-13" style={{ display: "grid", gap: 6 }}>
              <div className="u-between"><span className="u-muted">{tx("เบอร์โทร", "Phone")}</span><span>{branch.phone}</span></div>
              <div className="u-between"><span className="u-muted">{tx("เวลาเปิด-ปิด", "Hours")}</span><span>{branch.openTime} - {branch.closeTime}</span></div>
            </div>
          </Card>
        ))}
      </div>

      <Modal
        open={open}
        title={tx("เพิ่มสาขาใหม่", "New branch")}
        onClose={() => setOpen(false)}
        footer={
          <>
            <Button onClick={() => setOpen(false)}>{tx("ยกเลิก", "Cancel")}</Button>
            <Button variant="primary" onClick={save}>{tx("บันทึก", "Save")}</Button>
          </>
        }
      >
        <Input label={tx("ชื่อสาขา", "Branch name")} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        <Input label={tx("เบอร์โทร", "Phone")} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
        <Input label={tx("ที่อยู่", "Address")} value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} />
        <div className="grid-2">
          <Input label={tx("เวลาเปิด", "Open time")} type="time" value={form.openTime} onChange={(e) => setForm({ ...form, openTime: e.target.value })} />
          <Input label={tx("เวลาปิด", "Close time")} type="time" value={form.closeTime} onChange={(e) => setForm({ ...form, closeTime: e.target.value })} />
        </div>
      </Modal>
    </>
  );
}
